import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ApiService } from "src/app/auth-o3/shared/services/api.service";
import { CalendarType, FinancialCalendar } from "src/app/product-capture/model/interfaces/trading-calendar.interface";
import { environment } from "src/environments/environment";
import { STATIC_DATA_ENDPOINTS } from "./static-data-endpoints.const";

const HOSTNAME_STATIC_DATA_ENDPOINT = environment.api.staticData;

@Injectable({
    providedIn: 'root'
})
export class FinancialCalendarService {

    constructor(private apiService: ApiService) { }

    getAllOfType(type: CalendarType, group?: boolean): Observable<FinancialCalendar[]> {
        return this.apiService
        .getWithParams(
          STATIC_DATA_ENDPOINTS.TRADING_CALENDARS,
          { 
            type,
            ...(group && { group }),
         },
          HOSTNAME_STATIC_DATA_ENDPOINT
        )
        .pipe(
          map((data: FinancialCalendar[]) => {
            return !group ? this.dateStringTimeRemoval(data) : data;
          })
        );
    }

    add(data: FinancialCalendar): Observable<FinancialCalendar> { 
        const newTradingCalendarRecord = {
            ...data,
            date: data.date,
        };

        return this.apiService.post(
            STATIC_DATA_ENDPOINTS.TRADING_CALENDAR,
            newTradingCalendarRecord,
            HOSTNAME_STATIC_DATA_ENDPOINT
        );
    }

    edit(oldCalendar: FinancialCalendar, data: FinancialCalendar): Observable<FinancialCalendar> {
        const { calendarCode, date, type } = oldCalendar;
        return this.apiService.put(
            `${STATIC_DATA_ENDPOINTS.TRADING_CALENDAR}/${calendarCode}/${type}/${date}`,
            data,
            HOSTNAME_STATIC_DATA_ENDPOINT
          );
    }

    delete({ calendarCode, date, type }: FinancialCalendar): Observable<FinancialCalendar> {
        return this.apiService.deleteNoBody(
            `${STATIC_DATA_ENDPOINTS.TRADING_CALENDAR}/${calendarCode}/${type}/${date}`,
            HOSTNAME_STATIC_DATA_ENDPOINT
        );
    }

    dateStringTimeRemoval(data: any): Array<FinancialCalendar> {
        return data.map((entry) => {
          entry.date = entry.date.split(' ')[0];
          return entry;
        });
      }
}